/***
 * A primitive is JSON Schema with a few extra ServiceNow specific fields, it
 * has the following structure:
 *
 * interface Schema extends JSONSchema {
 *   nowName: string,
 *   nowLabel: string,
 *   nowDescription: string
 * }
 */

export const table = {
	nowName: 'table',
	nowLabel: 'Table Name',
	nowDescription: 'The name of the table',
	type: 'string'
};

export const sysId = {
	nowName: 'sys-id',
	nowLabel: 'Sys ID',
	nowDescription: 'The unique record identifier',
	type: 'string',
	pattern: '^[a-f0-9]{32}$'
};

export const query = {
	nowName: 'query',
	nowLabel: 'Query',
	nowDescription: 'The query to filter the result set',
	type: 'string'
};
